import { BaseCommand } from './BaseCommand.js';
import { BuildManager } from '../build/BuildManager.js';

export class PreviewCommand extends BaseCommand {
	async execute(options: any): Promise<void> {
		try {
			console.log('[Frame] Starting preview server...');

			const buildManager = new BuildManager(this.cwd);

			// First try Vite preview, if that fails, fall back to simple static server
			try {
				await buildManager.preview({
					port: options.port || 4173,
					host: options.host || 'localhost',
				});
			} catch (viteError) {
				console.log('[Frame] Vite preview failed, using fallback static server...');
				await buildManager.previewFallback({
					port: options.port || 4173,
					host: options.host || 'localhost',
				});
			}

		} catch (error) {
			console.error('[Frame] Preview failed:', error);
			process.exit(1);
		}
	}
} 